import angular from 'angular';
import AuthorisationService from './authorisation.service.js';
import AuthorisationInterceptor from './authorisation.interceptor.js'

let authorisationModule = angular.module('authorisation', [])

    .service('AuthorisationService', AuthorisationService)
    .service('AuthorisationInterceptor', AuthorisationInterceptor)

    .config(['$httpProvider',function($httpProvider){
        "ngInject";

        $httpProvider.interceptors.push('AuthorisationInterceptor');
    }])

    .name;

export default authorisationModule;